module.exports = __webpack_public_path__ + "static/egyptian-bedding-set-grey-1-9051129f2cea95db08a4621c34bde2d5.png";